/*-----------------------------------------------------------------------------/
/ Thread colour deep links - jw-multi-thread template ONLY
/
/ "Mettler METROSENE Sewing Thread - 150m" and "Gutermann Sew All Thread - 100m"
/ are each split across several products because of Shopify's 99-variant limit.
/ The base product page renders one combined Color dropdown that lists every
/ colour from all of the sibling products (see snippets/product-options.liquid).
/
/ Liquid can only preselect a variant that belongs to the product it is rendering
/ (product.selected_or_first_available_variant), so a link such as
/
/   /products/mettler-metrosene-sewing-thread-150m?variant=49621616197934
/
/ that points at a colour living on ...-150m-1 silently falls back to the first
/ colour of the base product. This resolves the variant id against the combined
/ dropdown instead, then lets theme.js do the rest.
/
/ It also syncs the other direction: picking a colour image in the gallery
/ (thumbnail click, arrows or swipe) updates the Color dropdown to match. The
/ theme only syncs dropdown -> image, so without this the dropdown kept showing
/ the old colour number while the image showed a different one.
/
/ Loaded only from sections/main-product.liquid, inside the
/ `product.template_suffix == 'jw-multi-thread'` guard, so no other template is
/ affected. Self-contained; the gallery sync uses jQuery only because slick's
/ afterChange is a jQuery event (the URL preselect does not need it).
/-----------------------------------------------------------------------------*/

(function () {
  var SELECT_SELECTOR = '.jw-color-option-selector.single-option-selector';
  var done = false;

  function findOptionByVariantId(select, variantId) {
    // Matched by iteration rather than an attribute selector so a malformed
    // ?variant= value can never be interpolated into a query.
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].getAttribute('data-var-id') === variantId) {
        return select.options[i];
      }
    }
    return null;
  }

  function preselectVariantFromUrl() {
    if (done) return;
    done = true;

    var select = document.querySelector(SELECT_SELECTOR);
    if (!select) return; // not the combined page - nothing to do

    var variantId = new URLSearchParams(window.location.search).get('variant');
    if (!variantId) return;

    var option = findOptionByVariantId(select, variantId);
    if (!option || option.selected) return; // unknown id, or already correct

    select.value = option.value;

    // Native and bubbling, so both <variant-mixed-inputs> (theme.js) and the
    // jQuery gallery sync in custom.js pick it up.
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // --- Gallery -> dropdown ------------------------------------------------

  var variants = null;

  function getVariants() {
    if (variants) return variants;
    var json = document.querySelector('variant-mixed-inputs script[type="application/json"]');
    try {
      variants = json ? JSON.parse(json.textContent) : [];
    } catch (e) {
      variants = [];
    }
    return variants;
  }

  // Combined page: gallery thumbnails carry the variant id of their colour
  // (id="jw-gallery-target-var-id-{id}" in snippets/product-gallery.liquid).
  function findCombinedOption(select, gallery, slideIndex) {
    var thumb = gallery.querySelector(
      '.thumbnail[data-slide-number="' + slideIndex + '"][id^="jw-gallery-target-var-id-"]'
    );
    if (!thumb) return null;
    return findOptionByVariantId(select, thumb.id.replace('jw-gallery-target-var-id-', ''));
  }

  // Regular page: match the slide's media against each variant's featured media.
  function findRegularOption(select, slide) {
    var mediaId = Number(slide.getAttribute('data-media-id'));
    if (!mediaId) return null;

    var list = getVariants();
    for (var i = 0; i < list.length; i++) {
      var media = list[i].featured_media;
      if (media && media.id === mediaId) {
        for (var j = 0; j < select.options.length; j++) {
          if (select.options[j].value === list[i].option1) return select.options[j];
        }
        return null;
      }
    }
    return null; // e.g. a lifestyle shot not tied to any colour
  }

  function syncDropdownToSlide(slider, slideIndex) {
    var product = slider.closest('product-single');
    if (!product) return;

    var slide = slider.querySelector('.media-gallery__item[data-slide-id="' + slideIndex + '"]');
    if (!slide) return;

    var select = product.querySelector(SELECT_SELECTOR);
    var option = select
      ? findCombinedOption(select, product, slideIndex)
      : null;

    if (!select) {
      select = product.querySelector('variant-mixed-inputs select[name="options[Color]"]');
      if (!select) return;
      option = findRegularOption(select, slide);
    }

    // Already showing this colour - also stops the dropdown -> gallery -> dropdown loop.
    if (!option || option.selected) return;

    select.value = option.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function bindGallerySync() {
    var $ = window.jQuery;
    if (!$) return;

    // Slick fires afterChange for thumbnail clicks, arrows and swipes alike.
    // Delegated, so it works regardless of when theme.js initialises slick.
    $(document).on('afterChange', 'product-single .js-product-slider', function (event, slick, currentSlide) {
      if (event.target !== this) return; // ignore nested sliders
      syncDropdownToSlide(this, currentSlide);
    });
  }

  function init() {
    bindGallerySync();

    // Wait for theme.js to upgrade <variant-mixed-inputs>, otherwise the change
    // event fires before that element has attached its listener.
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('variant-mixed-inputs').then(preselectVariantFromUrl);
      // Fallback in case theme.js never registers the element.
      window.setTimeout(preselectVariantFromUrl, 2000);
    } else {
      preselectVariantFromUrl();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
